<template lang="pug">
.accordeon
  h3(v-html="block.title")
  |
  .accordeon-container
    .collapse.collapse-arrow(
      v-for="(q, i) in qa"
      :key="i"
    )
      input(type="radio" name="my-accordion-2" :checked="checked")
      .collapse-title.text-xl.font-medium.flex
        //- .w-16.min-w-16 0{{ i + 1 }}.
        div {{ q.question }}
      .collapse-content
        p {{ q.answer }}
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { TBlock } from "@/models/block";

interface IProps {
  block?: TBlock | null;
}

const props = withDefaults(defineProps<IProps>(), {
  block: null,
});

const checked = ref(false);

const qa = computed(() => props.block?.faqs || []);
</script>

<style lang="sass" scoped>
.accordeon
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  padding-top: 144px
  padding-bottom: 144px

  h3
    margin-bottom: 106px
    color: #074033
    text-align: center
    font-size: 40px
    font-style: normal
    font-weight: 800
    line-height: 47px

  &-container
    width: 955px

    .collapse
      // padding-top: 8px

    .collapse-title
      color: #074033
      font-size: 24px
      font-style: normal
      font-weight: 700
      line-height: 29px
      padding-left: 0
      padding-right: 0

    .collapse-arrow > .collapse-title:after
      width: 10px
      height: 10px

    .collapse-content
      width: 820px

      & p
        color: var(--tealgreen-800, #074033)
        font-size: 18px
        font-style: normal
        font-weight: 500
        line-height: 26px

@media (max-width: 768px)
  .accordeon
    height: auto
    padding-top: 60px
    padding-bottom: 60px

    &-container
      width: 100%
      padding: 0 20px

    h3
      font-size: 24px
      line-height: 29px 
      margin-bottom: 28px

    .collapse-title
      font-size: 16px
      font-weight: 700
      line-height: 23px

      div:first-child
        width: 85%

    .collapse-content
      width: 85%
      padding-left: 0
      padding-right: 0
      font-size: 16px
      font-weight: 500
      line-height: 23px
</style>